module.exports = __webpack_public_path__ + "img/grid.72abdefd.svg";